import { factorySetStateAction } from '../factory'

const actions = {
  SET_STATE: 'dashboard/SET_STATE',
  GET_CLINIC_PATIENTS_DB: 'dashboard/GET_CLINIC_PATIENTS_DB',
  SET_DASHBOARD_TYPE: 'dashboard/SET_DASHBOARD_TYPE',
  GET_CLINIC_PATIENTS_DB_OTHER_DATA: 'dashboard/GET_CLINIC_PATIENTS_DB_OTHER_DATA',
}

export const dashboardSetState = factorySetStateAction(actions.SET_STATE)

export const getPatientsDBOtherData = (payload) => ({
  type: actions.GET_CLINIC_PATIENTS_DB_OTHER_DATA,
  payload,
})

// export const getPatientTimeInBedData = (data) =>
//   http
//     .get(apiPaths.Clinic.apiPatientTimeInBedData, data, {})
//     .then((res) => res)
//     .catch(() => [])

// export const getDeviceRScore = (data) =>
//   http
//     .get(apiPaths.Clinic.apiDeviceRScore, data, {})
//     .then((res) => res)
//     .catch(() => [])

export default actions
